<template>
    <div>
        <div v-if="candidate !== null">
            <input type="hidden" name="candidate" :value="candidate.id">
        </div>
        <vue-select label="name" :filterable="false" :options="options" @search="onSearch" v-model="candidate">
            <template slot="no-options">
                Type to search candidates
            </template>
            <template slot="option" slot-scope="option">
                <div class="d-center">
                    <img :src='photo(option)' class="image" /> 
                    {{ option.full_name }} ({{ option.mobile_number }})
                </div>
            </template>
            <template slot="selected-option" slot-scope="option">
                <div class="selected d-center">
                    <img :src='photo(option)' class="image"/> 
                    {{ option.full_name }} ({{ option.mobile_number }})
                </div>
            </template>
        </vue-select>
    </div>
</template>
<script>
import VueSelect from 'vue-select';

import axios from 'axios';
import { debounce } from 'lodash';

export default {
    components: {
        VueSelect
    },

    data() {
        return {
            options: [],
            candidate: null
        }
    },

    methods: {
        photo(candidate) {
            if (!candidate.parsed_id_values) {
                return '/img/female.png';
            }

            if (!candidate.photo_path_cdn) {
                return `/img/${candidate.parsed_id_values.gender.toLowerCase()}.png`;
            }

            return candidate.photo_path_cdn;
        },

        onSearch (search, loading) {
            if (search.length) {
                loading(true);
                this.search(search, loading);
            }
        },

        search: debounce(async function(search, loading) {
            try {
                const xhr = await axios.post('/ajax/get-candidates', {
                    search
                });

                this.options = xhr.data;
            } catch (error) {
                console.log(error.response);
            }

            loading(false);
        }, 500, {'maxWait': 1000})
    }
}
</script>